import type { Discount } from "@workspace/crystallize/generated/shop/cart/";
import { Badge } from "@workspace/ui/components/badge";

export const DiscountBadge = ({ discounts }: { discounts: Discount[] }) => {
	return (
		<Badge className="bg-primary-500 px-3">-{discounts[0]?.percent}%</Badge>
	);
};
